/** @format */

import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ShipmentDialog({
  openDialog,
  closeDialog,
  dialogTitle,
  dialogBody,
  actionButtonLabel,
  handelActionButton,
  anotherActionButtonLabel = false,
  handelAnotherActionButton = null,
}) {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => navigate("/shipment-and-payment-list")}
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{dialogTitle}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => navigate("/shipment-and-payment-list")}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogBody}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeDialog();
              handelActionButton(true);
            }}>
            {actionButtonLabel}
          </Button>
          {anotherActionButtonLabel && (
            <Button
              onClick={() => {
                closeDialog();
                handelAnotherActionButton(true);
              }}>
              {anotherActionButtonLabel}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
